import {
  createStyles, Theme,
} from '@material-ui/core/styles';

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    marginTop: 60,
    maxWidth: "100%",
    backgroundColor: '#FFF',
    [theme.breakpoints.down(465)]: {
      marginTop: 54,
    },
  },
});

export default styles;
